import { ArticleSource } from '../../types';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

interface SourcesListProps {
  sources: ArticleSource[];
}

const TYPE_LABELS: Record<string, string> = {
  official: 'Comunicado oficial',
  regulatory: 'Documento regulatório',
  technical: 'Documentação técnica',
  news: 'Imprensa',
  social: 'Rede social',
  other: 'Outra',
};

/** Lista de fontes com tipo, classificação primária/secundária e data de acesso. */
export const SourcesList: React.FC<SourcesListProps> = ({ sources }) => {
  if (!sources || sources.length === 0) return null;

  return (
    <section className="bg-white border border-gray-200 rounded-xl p-6 mb-6">
      <h2 className="text-lg font-bold text-gray-900 mb-4">Fontes utilizadas</h2>
      <ul className="space-y-3">
        {sources.map((source) => (
          <li key={source.id} className="flex flex-wrap items-center gap-x-3 gap-y-1 text-sm">
            <a
              href={source.url}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="font-semibold text-blue-600 hover:underline inline-flex items-center gap-1"
            >
              {source.name}
              <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
              </svg>
            </a>
            <span
              className={`px-2 py-0.5 rounded-full text-xs font-semibold ${
                source.isPrimary ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-600'
              }`}
            >
              {source.isPrimary ? 'Fonte primária' : 'Fonte secundária'}
            </span>
            <span className="text-gray-400 text-xs">
              {TYPE_LABELS[source.type] || source.type} · acesso em{' '}
              {format(new Date(source.accessedAt), 'dd/MM/yyyy', { locale: ptBR })}
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
};
